import { createSlice } from "@reduxjs/toolkit";

const baseState = {
  deviceId: null,
  deviceName: null,
  assignedEmployeeId: null,
  assignedEmployees: [],
  assignedCategories: [],
  assignedAt: null,
  branchId: null,
  allowSpecialItems: false,
};

const loadInitialState = () => {
  try {
    if (typeof window === "undefined") {
      return { ...baseState };
    }
    const saved = window.localStorage.getItem("posDevice");
    if (!saved) {
      return { ...baseState };
    }
    const parsed = JSON.parse(saved);
    return {
      ...baseState,
      ...parsed,
      assignedEmployees: Array.isArray(parsed?.assignedEmployees)
        ? parsed.assignedEmployees
        : [],
      assignedCategories: Array.isArray(parsed?.assignedCategories)
        ? parsed.assignedCategories
        : [],
      allowSpecialItems: Boolean(parsed?.allowSpecialItems),
    };
  } catch (error) {
    console.warn("Failed to load POS device from storage", error);
    return { ...baseState };
  }
};

const persistDeviceState = (data) => {
  try {
    if (typeof window === "undefined") return;
    if (!data || !data.deviceId) {
      window.localStorage.removeItem("posDevice");
    } else {
      window.localStorage.setItem("posDevice", JSON.stringify(data));
    }
  } catch (error) {
    console.warn("Failed to persist POS device", error);
  }
};

const initialState = loadInitialState();

const posDeviceSlice = createSlice({
  name: "posDevice",
  initialState,
  reducers: {
    setPosDevice(state, action) {
      const payload = action.payload;
      if (!payload || !payload.deviceId) {
        state.deviceId = null;
        state.deviceName = null;
        state.assignedEmployeeId = null;
        state.assignedEmployees = [];
        state.assignedCategories = [];
        state.assignedAt = null;
        state.branchId = null;
        state.allowSpecialItems = false;
        persistDeviceState(null);
        return;
      }

      const {
        deviceId,
        deviceName,
        assignedEmployeeId,
        assignedEmployees,
        assignedCategories,
        assignedAt,
        branchId,
        allowSpecialItems,
      } = payload;

      state.deviceId = deviceId ? deviceId.toString() : null;
      state.deviceName = deviceName ?? null;
      state.assignedEmployeeId = assignedEmployeeId ?? null;
      state.assignedEmployees = Array.isArray(assignedEmployees)
        ? assignedEmployees
        : [];
      state.assignedCategories = Array.isArray(assignedCategories)
        ? assignedCategories
        : [];
      state.assignedAt = assignedAt ?? null;
      state.branchId = branchId ?? null;
      state.allowSpecialItems = Boolean(allowSpecialItems);
      persistDeviceState({
        deviceId: state.deviceId,
        deviceName: state.deviceName,
        assignedEmployeeId: state.assignedEmployeeId,
        assignedEmployees: state.assignedEmployees,
        assignedCategories: state.assignedCategories,
        assignedAt: state.assignedAt,
        branchId: state.branchId,
        allowSpecialItems: state.allowSpecialItems,
      });
    },
    resetPosDevice() {
      persistDeviceState(null);
      return { ...baseState };
    },
  },
});

export const { setPosDevice, resetPosDevice } = posDeviceSlice.actions;
export default posDeviceSlice.reducer;
